import React from "react";
import { Link, makeStyles } from "@material-ui/core";
import { Grid, Typography, Box } from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";

export default function BottomPart() {
  const useStyles = makeStyles({
    Body: {
      maxWidth: "1920px",
      margin: "0 auto",
      overflow: "hidden",
      backgroundColor: "#f6f5f1",
    },
    
    root: {
      display: "block",
      color: "#252525",
    },
  });

  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();

  return (
    <div className={classes.Body}>
      <Grid container style={{ marginTop: 35, marginBottom: 35 }} spacing={2}>
        <Grid xs={12} sm={6} md={3} item>
          <Typography className={classes.root}>
            <Link
              href="#"
              style={{ fontWeight: "bold" }}
              onClick={preventDefault}
              color="textPrimary"
            >
              GIỚI THIỆU
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Phương thức hoạt động của HANNI
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Trang tin tức
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              HotelTonight
            </Link>
          </Typography>
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          <Typography className={classes.root}>
            <Link
              href="#"
              style={{ fontWeight: "bold" }}
              onClick={preventDefault}
              color="textPrimary"
            >
              CỘNG ĐỒNG
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Sự đa dạng và Cảm giác thân thuộc
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Tiện nghi phù hợp cho người khuyết tật
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Đối tác liên kết HANNI
            </Link>
          </Typography>
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          <Typography className={classes.root}>
            <Link
              color="textPrimary"
              href="#"
              style={{ fontWeight: "bold" }}
              onClick={preventDefault}
            >
              ĐÓN TIẾP KHÁCH
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Cho thuê nhà
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Tổ chức Trải nghiệm trực tuyến
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Đón tiếp khách có trách nhiệm
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Ngôi nhà rộng mở
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Trung tâm cộng đồng
            </Link>
          </Typography>
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          <Typography className={classes.root}>
            <Link
              color="textPrimary"
              href="#"
              style={{ fontWeight: "bold" }}
              onClick={preventDefault}
            >
              HỖ TRỢ
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Thông tin cập nhật về COVID-19
            </Link>
            <br />
            <Link
              color="textPrimary"
              variant="body2"
              href="#"
              onClick={preventDefault}
            >
              Trung tâm trợ giúp
            </Link>
            <br />
          </Typography>
        </Grid>
      </Grid>
      <hr width="1200px" />
      <div>
        <Grid container xs={12}>
          <Grid
            item
            xs={12}
            md={8}
            container
            alignItems="center"
            spacing={2}
            justify="center"
          >
            <Grid
              item
              xs={12}
              md={5}
              container
              alignItems="center"
              justify="center"
            >
              <Typography style={{ textAlign: "center" }}>
                @ 2020 Hanni, Inc. All rights reserved{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Link color="textPrimary">• Quyền riêng tư</Link>
            </Grid>
            <Grid item>
              <Link color="textPrimary">• Điều khoản </Link>
            </Grid>
            <Grid item>
              <Link color="textPrimary">• Sơ đồ trang web</Link>
            </Grid>
          </Grid>
          <Grid
            style={{ margin: "auto 0" }}
            xs={12}
            md={4}
            item
            container
            spacing={3}
            justify="center"
            alignItems="center"
          >
            <Box item md={6} display={{ xs: "none", md: "block" }}></Box>
            <Grid item>
              <FacebookIcon />
            </Grid>
            <Grid item>
              <InstagramIcon item />
            </Grid>
            <Grid item>
              <TwitterIcon item />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
